import React from 'react';
import PropTypes from 'prop-types';
import { H4, P } from 'components/Typography';
import Button, { BackButton } from 'components/Button';
import FadeInImage from 'components/FadeInImage';
import VeryHappy from 'products/nomad_insurance/assets/img/nps/very_happy.png';
import Happy from 'products/nomad_insurance/assets/img/nps/happy.png';
import Disappointed from 'products/nomad_insurance/assets/img/nps/disappointed.png';
import { Container, LeftColContainer, LeftCol, Buttons, ImageContainer } from './styled';

const ImprovementIdea = ({
  productTitle,
  onNextClick,
  onPrevClick,
  onSuggestionChange,
  onSocialMediaPostUrlChange,
  rating,
  campaign,
  suggestion,
  socialMediaPostUrl
}) => {
  const getImageSrc = () => {
    if (rating <= 5) {
      return Disappointed;
    }
    if (rating <= 7) {
      return Happy;
    }
    return VeryHappy;
  };
  return (
    <Container>
      <LeftColContainer>
        {campaign === 'claims_ni' ? (
          <LeftCol>
            <P>
              Share your feedback on your favorite social media platform and get a $10
              amazon gift card &#128176;. Paste the link of your post below and we will
              send you your reward shortly.
            </P>
            <textarea onChange={onSocialMediaPostUrlChange} value={socialMediaPostUrl} />
          </LeftCol>
        ) : (
          <LeftCol>
            <H4>Want to earn $100?</H4>
            <P>
              Tell us how we can improve {productTitle} and the best new ideas will
              receive $100 once they are implemented.
            </P>
            <textarea onChange={onSuggestionChange} value={suggestion} />
          </LeftCol>
        )}
        <Buttons>
          <BackButton onClick={onPrevClick}>Back</BackButton>
          <Button onClick={onNextClick}>Submit</Button>
        </Buttons>
      </LeftColContainer>
      <ImageContainer>
        <FadeInImage src={getImageSrc()} />
      </ImageContainer>
    </Container>
  );
};

ImprovementIdea.propTypes = {
  productTitle: PropTypes.string.isRequired,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onSuggestionChange: PropTypes.func.isRequired,
  onSocialMediaPostUrlChange: PropTypes.func.isRequired,
  suggestion: PropTypes.string,
  socialMediaPostUrl: PropTypes.string,
  rating: PropTypes.number,
  campaign: PropTypes.string
};

export default ImprovementIdea;
